var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0017 34.4107C25.6044 34.4107 24.5657 35.5375 24.5657 36.9286C24.5657 38.3186 25.6993 39.4464 27.0017 39.4464C28.399 39.4464 29.4377 38.3186 29.4377 36.9286C29.5326 35.5333 28.4042 34.4107 27.0017 34.4107ZM27.0017 30.2143C27.9342 30.2143 28.5941 29.4635 28.5941 28.5357V13.4286C28.5941 12.5007 27.8395 11.75 27.0017 11.75C26.1638 11.75 25.3144 12.5054 25.3144 13.4286V28.5357C25.3144 29.4589 26.0737 30.2143 27.0017 30.2143ZM53.1863 38.3239L32.1163 2.87246C31.0512 1.07743 29.1319 0.00314732 27.0017 0C24.8715 0 22.9627 1.07219 21.8871 2.87036L0.806526 38.3302C-0.253302 40.1105 -0.26912 42.2475 0.762045 44.0478C1.82839 45.8984 3.75401 47 5.92112 47H48.0928C50.2557 47 52.1792 45.8953 53.2401 44.0447C54.2725 42.2475 54.2514 40.1074 53.1863 38.3239ZM50.2124 42.2895C49.8539 43.1708 49.0208 43.6429 47.9979 43.6429H5.92112C4.98193 43.6429 4.15158 43.1724 3.69812 42.3839C3.26807 41.6332 3.27471 40.7788 3.71459 40.0381L24.7977 4.5804C25.2511 3.81455 26.0737 3.35714 27.0017 3.35714C27.926 3.35878 28.748 3.81445 29.2015 4.5783L50.2821 40.0381C50.6343 40.7788 50.7397 41.6286 50.2124 42.2895Z",
    fill: "#FF964D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.709b2f0df349d6c0f900ae8d6873f437.svg";
export { ForwardRef as ReactComponent };